import request from "@/axios";
/** 投屏收费管理页面 */
/** 分页线上查询 */
export const getScreenChargeList = params => {
  return request({
    url: "/lebo-member/web/member/paidStrategy/page",
    method: "get",
    params
  });
};

/** 分页本地查询 */
export const getScreenChargeListLocal = params => {
  return request({
    url: "/lebo-member/web/member/paidStrategy-local/page",
    method: "get",
    params
  });
};

/** 新增投屏收费策略 */
export const addScreenChargeLocal = data => {
  return request({
    url: "/lebo-member/web/member/paidStrategy-local/save",
    method: "post",
    data
  });
};
/** 修改投屏收费策略 */
export const updateScreenChargeLocal = data => {
  return request({
    url: "/lebo-member/web/member/paidStrategy-local/update",
    method: "post",
    data
  });
};

/** 删除投屏收费策略 */
export const deleteScreenChargeLocal = id => {
  return request({
    url: "/lebo-member/web/member/paidStrategy-local/delById",
    method: "get",
    params: {
      id
    }
  });
};

/** 提交审核  */
export const submitAudit = id => {
  return request({
    url: "/lebo-member/web/member/paidStrategy-local/submit",
    method: "post",
    params: {
      id
    }
  });
};

/** 取消审核  */
export const cancelAudit = id => {
  return request({
    url: "/lebo-member/web/member/paidStrategy-local/cancelAudit",
    method: "post",
    params: {
      id
    }
  });
}

/** 获取日志列表  */
export const getLogList = params => {
  return request({
    url: "/lebo-member/web/member/operation-log/page",
    method: "get",
    params
  });
}

